var previous = "previous";
var next = "next";
var confirm = "confirm";
var free = "free";
var preview = "preview";
var loading = "loading";
var upload = "upload";
var uploading = "uploading";
var cancel = "cancel";
var order = "order";
var done = "done";
var change = "change";
var or = "or";
var crop = "crop";
var checkout = "checkout";
var replace = "replace";
var revoke = "revoke";
var warning = "warning";
var en_US = {
	"customize.now": "customize now",
	"add.cart": "add to cart",
	"no.thanks.add.cart": "no thanks & add to cart",
	previous: previous,
	next: next,
	"continue": "continue",
	confirm: confirm,
	"confirm.design": "confirm design",
	free: free,
	preview: preview,
	loading: loading,
	upload: upload,
	uploading: uploading,
	"delete": "delete",
	cancel: cancel,
	order: order,
	done: done,
	change: change,
	or: or,
	crop: crop,
	"crop.image": "crop image",
	"crop.myself": "crop by myself",
	checkout: checkout,
	replace: replace,
	revoke: revoke,
	warning: warning,
	"zoom.pinch": "pinch and zoom",
	"try.again": "please try again",
	"error.upload": "upload error",
	"error.network": "network error"
};

var I18n = function () {
  function I18n() {
    var _this = this;

    this._resources = {};
    this._lng = 'en_US';

    this.mount = function (resources) {
      Object.keys(resources).forEach(function (lng) {
        _this._resources[lng] = Object.assign(_this._resources[lng] || {}, resources[lng]);
      });
    };

    this.mountLng = function (lng, resource) {
      _this._resources[lng] = Object.assign(_this._resources[lng] || {}, resource);
    };

    this.setLng = function (lng) {
      _this._lng = lng;
    };

    this._resources['en_US'] = en_US;
  }

  I18n.prototype.exists = function (key) {
    return !!this._resources[this._lng][key];
  };

  I18n.prototype.format = function (key, values) {
    if (values === void 0) {
      values = {};
    }

    var result = this._resources[this._lng][key];
    Object.keys(values).forEach(function (item) {
      var patt = new RegExp('{{' + item + '}}', 'g');
      result = result.replace(patt, values[item]);
    });
    return result;
  };

  return I18n;
}();

var index = new I18n();

export default index;
